import { useMutation, useQueryClient } from '@tanstack/react-query';

import httpService from '@/lib/http.service';
import { MutationConfig } from '@/lib/react-query';

export const deleteContractPerson = ({ personId }: { personId: number }) => {
  return httpService.delete(`/contracts/persons/${personId}`);
};

type UseDeleteContractPersonOptions = {
  mutationConfig?: MutationConfig<typeof deleteContractPerson>;
};

export const useDeleteContractPerson = ({ mutationConfig }: UseDeleteContractPersonOptions = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('contract-persons'),
      });
      onSuccess?.(...args);
    },
    ...restConfig,
    mutationFn: deleteContractPerson,
  });
};
